import BadgeAssigneeEdit from '@/screens/BadgeAssigneeEdit';

export default function PrivateBadgeAssigneeAssigneeIdEditRoute() {
  return <BadgeAssigneeEdit />;
}
